<template>
  <NoteSection
    label="Developed Symptoms"
  >
    <label class="font-weight-bold">1. Has the patient experienced any of the following since your last visit?</label>
    <check-boxes
      v-model="amnioResearchSymptoms"
      :items="symptoms"
      item-label="symptom"
      label="Check all that apply"
      class="col-sm-12 py-5"
      columns="2"
      return-object
      required
    ></check-boxes>
  </NoteSection>
</template>
<script>

export default {
  name: 'DevelopedSymptoms',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      symptoms: [
        { symptom: 'Fever (temperature ≥ 100.4°F or 38°C)' },
        { symptom: 'Chills' },
        { symptom: 'Unusual tiredness or fatigue' },
        { symptom: 'Headache' },
        { symptom: 'Muscle aches' },
        { symptom: 'Nausea or vomiting' },
        { symptom: 'Diarrhea' },
        { symptom: 'None of the above' },
      ],
    }
  },
  computed: {
    amnioResearchSymptoms: {
      get() {
        return this.value.map(item => this.symptoms.find(localSymptom => localSymptom.symptom === item.symptom)).filter(Boolean)
      },
      set(newVal) {
        const oldVal = this.value

        // Determine which symptom was most recently selected/deselected
        const added = newVal.find(
          newItem => !oldVal.some(oldItem => oldItem.symptom === newItem.symptom)
        )

        const removed = oldVal.find(
          oldItem => !newVal.some(newItem => newItem.symptom === oldItem.symptom)
        )

        const lastInteractedSymptom = added || removed

        const noneSelected = newVal.some(
          item => item.symptom === 'None of the above'
        )
        const othersSelected = newVal.some(
          item => item.symptom !== 'None of the above'
        )

        let updated = newVal

        if (lastInteractedSymptom?.symptom === 'None of the above' && othersSelected) {
          // User selected "None of the above" → clear all others
          updated = [{ symptom: 'None of the above' }]
        } else if (lastInteractedSymptom && lastInteractedSymptom.symptom !== 'None of the above' && noneSelected) {
          // User selected a real symptom while "None of the above" was selected → remove "None of the above"
          updated = newVal.filter(item => item.symptom !== 'None of the above')
        }

        this.$emit('input', updated)
      },
    },
  },
}
</script>
